module.exports = __webpack_public_path__ + "img/synopsis_006.3cecf13f.png";